import { REGION_API_KEYS } from '../helpers/DanmarksKortMap.constants.js'

export function useMapData(props) {
  const regionDataCache    = new Map()
  const pendingPrefetches  = new Map()
  const requestsByUrl      = new Map()

  const fetchRegionData = async (regionKey) => {
    if (regionDataCache.has(regionKey)) return regionDataCache.get(regionKey)

    const slug = REGION_API_KEYS[regionKey] ?? regionKey.toLowerCase().replace(/\s+/g, '-')
    const url  = props.municipalityDataUrl.replace('{key}', slug)

    let request = requestsByUrl.get(url)
    if (!request) {
      request = fetch(url).then((response) => {
        if (!response.ok) throw new Error(`map-data ${url}: ${response.status}`)
        return response.json()
      })
      requestsByUrl.set(url, request)
    }

    try {
      const data = await request
      regionDataCache.set(regionKey, data)
      return data
    } catch (err) {
      requestsByUrl.delete(url)
      throw err
    }
  }

  const prefetchRegionData = (regionKey) => {
    if (regionDataCache.has(regionKey) || pendingPrefetches.has(regionKey)) return
    pendingPrefetches.set(regionKey, fetchRegionData(regionKey).catch(() => pendingPrefetches.delete(regionKey)))
  }

  return { regionDataCache, fetchRegionData, prefetchRegionData }
}
